export default () => ({
  infos: [],
  entity: 'info',
  entities: 'infos',
  towers: [],
  errors: {}
})



// WEBPACK FOOTER //
// ./src/app/dweller/profile/me/components/overview/components/info/resources/data.js